/**
 * Configuration for the Face Landmarks Component
 */

export const CONFIG = {
  // Phase 1: Dots appearing
  dots: {
    perFrame: 4,
    appearDuration: 250
  },

  // Phase 2: Lines growing
  lines: {
    perFrame: 3,
    growDuration: 300,
    delayAfterDots: 100
  },

  // Phase 3: Fill animation
  fill: {
    delayAfterLines: 200,
    fadeInDuration: 900,
    delayBetweenQuads: 10,
    targetOpacity: 0.8,
    color: '#33FF33'
  },

  // Phase 4: Hold
  hold: {
    duration: 1000
  },

  // Phase 5: Fill fade out
  fillFadeOut: {
    duration: 1500
  },

  // Phase 6: Mesh fade to residual
  meshFade: {
    duration: 1000,
    targetAlpha: 0.3
  },

  // Landmark smoothing
  smooth: {
    factor: 0.2
  },

  // Mask appearance
  mask: {
    lineColor: '#FFFFFF',
    lineAlpha: 0.9,
    lineWidth: 1,
    pointSize: 2,
    regionAlpha: {
      oval: 0.3,
      lips: 0.25,
      leftEye: 0.2,
      rightEye: 0.2,
      iris: 0.1
    }
  },

  // Face tracking
  faceTracking: {
    minFaceSize: 0.3,
    ovalColor: '#FF3333',
    ovalAlpha: 1,
    ovalAspectRatio: 0.66,
    ovalRadiusY: 0.35,
    warningColor: '#FF3333',
    warningAlpha: 0.75,
    warningText: 'Position your face in the oval'
  },

  // Stability detection
  stability: {
    historySize: 30,
    threshold: 4
  },

  // MediaPipe model path (relative path for Mobile Safari compatibility)
  //mediaPipePath: '/mediapipe-face-mesh'
  //mediaPipePath: 'mediapipe-face-mesh'
  mediaPipePath: 'https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh'
};

export type Config = typeof CONFIG;
